import React, { useState } from 'react';
import { LoginSocialFacebook } from 'reactjs-social-login';
import Styles from '../Socials.module.scss';
import { error as errorToast } from 'helpers/toaster.js';
import { postFacebookIntegration } from 'services/integrationService';
import { useSelector } from 'react-redux';
import { getRequest } from 'helpers/axios';
import ErrorModal from 'Components/Modal/CampaignErrorModal/CampaignErrorModal';
import UpgradeModal from 'Containers/Modal/UpgradeModal/UpgradeModal';

const FacebookLoginComponent = ({ onLoginSuccess }) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ message: '', link: '' });
  const [showFacebookLogin, setShowFacebookLogin] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};

  const handleFacebookClick = async () => {
    try {
      // Check platform integration limits
      const limitResponse = await getRequest(
        'check_limits?type=platform_integration',
      );

      if (!limitResponse.data.success) {
        if (currentSubscription?.plan_name === 'Basic Plan') {
          setShowUpgradeModal(true);
        } else {
          setErrorDetails({
            message:
              limitResponse.data.message ||
              'You have reached your platform integration limit',
            link: limitResponse.data.link || '',
          });
          setErrorModal(true);
        }
      } else {
        // Only show Facebook login if limit check passes
        setShowFacebookLogin(true);
      }
    } catch (error) {
      // console.error('Error checking limits:', error);
      // setErrorDetails({
      //   message:
      //     error.response?.data?.error ||
      //     'Failed to check platform integration limits',
      //   link: '',
      // });
      // setErrorModal(true);

      setErrorDetails({
        message:
          error.response?.data?.error ||
          'You have reached your platform integration limit',
        link: 'https://appsumo.com/products/vocable-ai/?p=1',
      });

      if (currentSubscription?.plan_name === 'Basic Plan') {
        setShowUpgradeModal(true);
      } else {
        setErrorModal(true);
      }
    }
  };

  const handleFacebookLogin = async ({ data }) => {
    try {
      const accessToken = data?.accessToken;

      // Validate that we got a proper access token from fresh authorization
      if (!accessToken || !data?.userID) {
        console.error('Facebook login: No valid token received');
        setShowFacebookLogin(false);
        return;
      }

      await postFacebookIntegration({
        access_token: accessToken,
      });
      onLoginSuccess();
      setShowFacebookLogin(false);
    } catch (error) {
      const message =
        error.response?.data?.error?.message || error.response?.data?.error;
      errorToast(message);
      console.error('Facebook Login Error:', error);
      setShowFacebookLogin(false);
    }
  };

  return (
    <div>
      {showFacebookLogin ? (
        <LoginSocialFacebook
          appId={process.env.REACT_APP_FACEBOOK_OAUTH_APP_ID || '516068428115571'}
          scope="pages_manage_posts,pages_show_list,pages_read_engagement,business_management"
          isOnlyGetToken={true}
          onResolve={handleFacebookLogin}
          onReject={(error) => {
            console.error('Facebook login rejected:', error);
            setShowFacebookLogin(false);
          }}
        >
          <div className={`${Styles.IntegrationBtn} rounded-4`}>
            <img
              src={`/Images/logo-facebook.png`}
              alt={'facebook'}
              width="50"
              height="50"
            />
            <p>Facebook</p>
          </div>
        </LoginSocialFacebook>
      ) : (
        <div
          className={`${Styles.IntegrationBtn} rounded-4`}
          onClick={handleFacebookClick}
        >
          <img
            src={`/Images/logo-facebook.png`}
            alt={'facebook'}
            width="50"
            height="50"
          />
          <p>Facebook</p>
        </div>
      )}

      {showUpgradeModal && (
        <UpgradeModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
        />
      )}

      {errorModal && (
        <ErrorModal
          show={errorModal}
          onHide={() => setErrorModal(false)}
          errorMessage={errorDetails.message}
          errorLink={errorDetails.link}
        />
      )}
    </div>
  );
};

export default FacebookLoginComponent;
